export default "__VITE_PUBLIC_ASSET__5ca230cc__"